export default {
    methods: {
        formatValue(value) {
            return parseFloat(Number.parseFloat(value).toFixed(2)) || 0
        }
    }
}